
export const EVENTS_REPORT_RANGE_OPTIONS = [
     { value: 'today', label: 'Today' },
     { value: 'last_week', label: 'Last Week' },
     { value: 'last_2_weeks', label: 'Last 2 Weeks' },
     { value: 'last_month', label: 'Last Month' },
     { value: 'ytd', label: 'Year to Date' },
] as const;

export const GenericConstant: any = {

     deleteUserDialogTitle: "Delete User?",
     deleteUserDialogMsg: "Do you want to delete this user?",
     editUserBlankRoleTitle: "Warning",
     editUserBlankRoleMessage: "User will have no access as no roles selected. Do you want to confirm?",
     breederRoleTooltip: "View trials and processing progress",
     adminRoleTooltip: "Manage user access to the tool",
     'S2S-LeadTooltip': "Create, manage, track progress of SPLots and completion at trial & material level",
     'TechnicianTooltip': "Progress materials through the processing protocols on hand held device",
     PEOPLEPICKGROUPID: "09895d05-1b79-4529-9f9d-9367752a1d0a",
     PAPERSTYLE: {
          PaperProps: {
               style: { height: "auto", maxHeight: 250, top: 0 },
          }
     },
     USERDROPDOWNSTYLE: {
          "& .MuiSelect-select": {
               display: "flex",
               alignItems: "center",
               paddingTop: 0,
               paddingBottom: 0,
               paddingRight: "32px !important",
               height: "100%",
               fontSize: 14,
               fontWeight: 400,
               overflow: "hidden",
               textOverflow: "ellipsis",
               whiteSpace: "nowrap",
          }
     },
     UNSAVECHANGEPOPOP: "Are you sure to go back without saving?",
     CONFIRMATION: "Confirmation",
     USERMGMTPAGINATION: [20, 50, 100, 500],
     SPLOTTPAGINATION: [20, 50, 100, 500],
     WORKFLOWPROGRESS: "in progress",
     WORKFLOWSKIP: "skipped",
     WORKFLOWNOTSTARTED: "not started",
     WORKFLOWCOMPLETED: "completed",
     THRESHOLDREACHED: "threshold_reached",
     CHIPCOLOR: {
          SkippedColor: '#B50101',
          SkippedBgColor: '#FFD6D6',
          CompletedColor: '#008236',
          CompletedBgColor: '#DCFCE7',
          'In ProgressColor': '#7E2A0C',
          'In ProgressBgColor': '#FFDEC7'


     },
     STATUSCOLOR: {
          "completed": "#DCFCE7",
          "created": "#CBF5FB",
          "seed-extraction": "#FEF3C6",
          "fermentation": "#F9E8FF",
          "disinfection_1": "#FFE6E7",
          "disinfection_2": "#FFE9D4",
          "centrifuging": "#FEE3F3",
          "drying": "#E0E7FF",
          "blower-cleaning": "#E4F4FF",
          "manual-cleaning": "#FFFCD7",
          "packaging-&-labelling": "#E4E7E9",
          "mint-registeration": "#E9EBFF",
          "heat-treatment": "#ECFCCA",
          "ready-for-harvest": '#CBF5FB',
          "in-progress": "#FFDEC7"
     },
     DROPDOWNSTYLE: {
          fontWeight: 400,
          fontSize: 14,
          color: '#404040'
     },
     CHECKBOXSTYLE: {
          '&.Mui-checked': {
               color: '#000000',
          },
          color: '#000000',
          fontSize: 20

     },
     MUSELCHECKBOXSTYLE: {
          '&.Mui-checked': {
               color: '#161616',
          },
          "& .MuiSvgIcon-root": {
               fontSize: 20, color: "#161616"
          }

     },
     POSTSEASONMODULE: ["/splot", "/workflow", "/label-templates", "/mintRegistration", "/events-report"],
     INSEASONMODULE: ["/harvest-req"],
    
     createHarvestDialogMsg: "Are you sure you want to create another harvest ?",
     
     // Label print configuration
     // Number of label copies to print per page (arranged in grid format)
     // TODO: Replace with API config key when available
     LABELS_PER_PRINT_PAGE: 6,
     // Vertical gap/spacing between labels in mm (for multi-label printing)
     // IMPORTANT: This must match the physical label spacing of your printer paper
     // For 238×102 mm "Slip on tag" paper, verify actual label pitch with printer specs
     // Adjust this value if labels are not aligning with pre-printed positions
     LABEL_GRID_GAP_MM: 2,
     TOP_SITE_REQUIRED:["splot","trial","inSeasonTrials"],
     CHECK_EMPTY_EXCEPT:{
        "splot": ["site_code","is_archive"] ,
        "trail":[],
        "inSeasonTrialsMat":["trial_id","site_code"]
     }
     
   

}


